import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	giveFeedback: {
		id: 'spa-apps-sidebar-servicedesk.common.practice-queues.give-feedback-item.give-feedback',
		defaultMessage: 'Give feedback',
		description: 'Label of the button that a user will click on to provide feedback a the feature.',
	},
});
